module.exports = __webpack_public_path__ + "media/images/it/icons/home-5ae9e51f1d95e2a88dadb0e3d62cbbb9.svg";